import * as angular from 'angular';
import { PersistentMenuTemplate, MaxFirstLevelItems, } from './PersistentMenuConstants';
import { ChannelsNames } from '../../channels/Channels';
export class PersistentMenuController {
    static $inject = ['BlipToastService', 'ChannelsService', 'LoadingService', 'application', 'PersistentMenuService', '$window', '$scope', '$rootScope', '$translate'];
    constructor(BlipToastService, ChannelsService, LoadingService, application, PersistentMenuService, $window, $scope, $rootScope, $translate) {
        'ngInject';
        this.BlipToastService = BlipToastService;
        this.ChannelsService = ChannelsService;
        this.LoadingService = LoadingService;
        this.application = application;
        this.PersistentMenuService = PersistentMenuService;
        this.$translate = $translate;
        //Initial vars
        this.persistentMenu = PersistentMenuTemplate(MaxFirstLevelItems);
        this.menuHasChanged = false;
        //Method calls
        this.init();
        //Window/scope methods
        $window.onbeforeunload = this.alertPendingChanges.bind(this, true);
        $scope.$on('$stateChangeStart', this.alertPendingChanges.bind(this, false));
        $scope.$on('$destroy', () => ($window.onbeforeunload = undefined));
        //Broadcasts
        $rootScope.$on('menuHasChanged', () => {
            this.menuHasChanged = true;
        });
    }
    //
    normalizePersistentMenu(persistentMenu) {
        const normalizedPersistentMenu = persistentMenu;
        const persistentMenuLength = persistentMenu.options.length;
        for (let i = 0; i < MaxFirstLevelItems - persistentMenuLength; i++) {
            normalizedPersistentMenu.options.push({});
        }
        return normalizedPersistentMenu;
    }
    async init() {
        this.LoadingService.startLoading();
        try {
            const persistentMenu = await this.PersistentMenuService.getPersistentMenu(this.application);
            if (persistentMenu) {
                this.persistentMenu = this.normalizePersistentMenu(persistentMenu);
            }
            this.ChannelsService.init(this.application);
        }
        catch (err) {
            const errorMessage = await this.$translate('utils.errorMsg.3');
            this.BlipToastService.show('danger', {
                msg: errorMessage,
            });
            this.saveMenuError = err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async blankMenuError() {
        const errorMsg39 = await this.$translate('utils.errorMsg.39');
        this.BlipToastService.show('danger', {
            msg: errorMsg39,
        });
    }
    async boxMenuError() {
        const errorMsg1 = await this.$translate('persistentMenu.errorMsg.1');
        this.BlipToastService.show('danger', {
            msg: errorMsg1,
        });
    }
    async save(persistentMenu) {
        this.LoadingService.startLoading();
        if (!this.checkChannelsAreActive()) {
            const errorTitle = await this.$translate('persistentMenu.errorMsg.title');
            const errorMessage = await this.$translate('persistentMenu.errorMsg.3');
            this.BlipToastService.show('danger', {
                title: errorTitle,
                msg: errorMessage,
            });
            this.LoadingService.stopLoading();
            return;
        }
        const filteredMenu = this.filterMenuOptions(persistentMenu.options);
        if (!angular.equals(persistentMenu, PersistentMenuTemplate(MaxFirstLevelItems))) {
            // There is some information on menu component
            await this.savePersistentMenu(filteredMenu);
        }
        else {
            // There is no information on menu component
            await this.deletePersistentMenu();
        }
        this.LoadingService.stopLoading();
    }
    async savePersistentMenu(filteredMenu) {
        try {
            await this.PersistentMenuService.savePersistentMenu(this.application, filteredMenu);
            const successMessage = await this.$translate('utils.successMsg.8');
            this.BlipToastService.show('success', {
                msg: successMessage,
            });
            this.menuHasChanged = false;
        }
        catch (err) {
            const errorTitle = await this.$translate('persistentMenu.errorMsg.title');
            if (err.message.includes('Cód. 67')) {
                const errorMessage = await this.$translate('persistentMenu.errorMsg.2');
                this.BlipToastService.show('danger', {
                    title: errorTitle,
                    msg: errorMessage,
                });
                this.menuHasChanged = false;
            }
            else {
                this.BlipToastService.show('danger', {
                    title: errorTitle,
                    msg: err.message,
                });
            }
        }
    }
    async deletePersistentMenu() {
        try {
            this.PersistentMenuService.deletePersistentMenu(this.application);
            const successMessage = await this.$translate('utils.successMsg.8');
            this.BlipToastService.show('success', {
                msg: successMessage,
            });
            this.menuHasChanged = false;
        }
        catch (err) {
            const errorTitle = await this.$translate('persistentMenu.errorMsg.title');
            this.BlipToastService.show('danger', {
                title: errorTitle,
                msg: err.message,
            });
        }
    }
    checkChannelsAreActive() {
        const isWorkplaceActive = this.ChannelsService
            .isChannelActive(ChannelsNames.Workplace);
        const isMessengerActive = this.ChannelsService
            .isChannelActive(ChannelsNames.Messenger);
        return isWorkplaceActive || isMessengerActive;
    }
    filterMenuOptions(menuOptions) {
        return menuOptions.reduce((x, y) => {
            if (!angular.equals(y, {})) {
                x.options.push(y);
            }
            return x;
        }, { options: [] });
    }
    isMenuModified() {
        return this.menuHasChanged;
    }
    alertPendingChanges(isWindowClosing, e) {
        this.LoadingService.stopLoading();
        if (!this.isMenuModified()) {
            return;
        }
        const message = this.$translate.instant('modules.application.detail.persistentMenu.confirmationMessage');
        if (!isWindowClosing && !e.defaultPrevented && !confirm(message)) {
            e.preventDefault();
            return false;
        }
        e.returnValue = message;
        return message;
    }
}
PersistentMenuController.$inject = ['BlipToastService', 'ChannelsService', 'LoadingService', 'application', 'PersistentMenuService', '$window', '$scope', '$rootScope', '$translate'];
